// extracted by mini-css-extract-plugin
export default {"message_container":"PageNotFound_message_container__mRVTD","text":"PageNotFound_text__l7nY+"};